var map = {
	"./ADA.svg": 622,
	"./BCH.svg": 623,
	"./BNB.svg": 624,
	"./BTC.svg": 625,
	"./CHZ.svg": 626,
	"./DASH.svg": 627,
	"./DOGE.svg": 628,
	"./DOT.svg": 629,
	"./ETC.svg": 630,
	"./ETH.svg": 631,
	"./EUR.svg": 632,
	"./GBP.svg": 633,
	"./LINK.svg": 634,
	"./LTC.svg": 635,
	"./MATIC.svg": 636,
	"./MKR.svg": 637,
	"./SHIB.svg": 638,
	"./SOL.svg": 639,
	"./TRX.svg": 640,
	"./UNI.svg": 641,
	"./USD.svg": 642,
	"./USDT.svg": 643,
	"./XLM.svg": 644,
	"./XMR.svg": 645,
	"./XRP.svg": 646,
	"./documents.svg": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;